'use client';

import { styled } from '@linaria/react';

import { BREAKPOINTS } from '@/constants';

import Demo, { DemoInlineToggleControl } from '@/components/Demo';
import Checkbox from '@/components/Checkbox';
import Spacer from '@/components/Spacer';

function ButtonGradient() {
  return (
    <Demo
      id="button-layers"
      initialValues={{ showFront: true, showGradient: true }}
      CustomGridComponent={ControlsGrid}
      controls={[
        <DemoInlineToggleControl
          id="showFront"
          key="showFront"
          label="Show front layer"
        />,
        <DemoInlineToggleControl
          id="showGradient"
          key="showGradient"
          label="Show gradient"
        />,
      ]}
    >
      {({ showFront, showGradient }) => {
        const background = showGradient
          ? `linear-gradient(
              to left,
              hsl(340deg 100% 16%) 0%,
              hsl(340deg 100% 32%) 8%,
              hsl(340deg 100% 32%) 92%,
              hsl(340deg 100% 16%) 100%
            )`
          : 'hsl(340deg, 100%, 32%)';
        return (
          <Wrapper>
            <ButtonWrapper>
              <Backdrop style={{ '--background': background }} />
              <ButtonFace style={{ '--opacity': showFront ? 1 : 0 }}>
                Push Me
              </ButtonFace>
            </ButtonWrapper>
          </Wrapper>
        );
      }}
    </Demo>
  );
}

const ControlsGrid = styled.div`
  display: grid;
  gap: 16px;
  grid-template-columns: 1fr;

  @media ${BREAKPOINTS.smAndLarger} {
    grid-template-columns: 1fr 1fr;
    justify-items: center;
  }
`;

const Wrapper = styled.div`
  perspective: 500px;
  padding: 32px;
`;

const Label = styled.label`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ButtonWrapper = styled.button`
  perspective: inherit;
  transform-style: preserve-3d;
  transform-origin: center center;
`;

const Backdrop = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: var(--background);
  border-radius: 12px;
  transform-origin: center center;
`;

const ButtonFace = styled.span`
  display: block;
  padding: 12px 42px;
  border-radius: 12px;
  border: none;
  background: hsl(345deg 100% 46.5%);
  color: white;
  font-size: 20px;
  font-weight: 500;
  transform: translateY(-4px);
  /* Mouse-out styles */
  transition: all 250ms cubic-bezier(0.3, 0.7, 0.4, 1.5);
  opacity: var(--opacity);

  ${ButtonWrapper}:hover &,
  ${ButtonWrapper}:focus-visible & {
    transform: translateY(-6px);
    transition: all 250ms;
  }
  ${ButtonWrapper}:active & {
    transform: translateY(-2px);
    transition: all 25ms;
  }
`;

export default ButtonGradient;
